<div class="create-new-point-container">
  <div class="empty-state-content">
    <div class="empty-state-icon">
      <img src="assets/icons/recycle.svg" alt="Crear punto" class="icon-xxlarge icon-primary">
    </div>
    
    <div class="empty-state-text">
      <h3 class="empty-state-title h3-bold text-secondary text-center">{{ 'createNewPoint.noPointsFound' | t }}</h3>
      <p class="empty-state-description h4 text-secondary text-center">
        {{ 'createNewPoint.noPointsMatchDescription' | t }}
      </p>
    </div>
    
    <div class="empty-state-action primary-invert-color-button btn-l push-btn">
      <button 
        class="create-point-btn  btn-l h3-semibold inner-button " 
        (click)="createNewPoint()"
        type="button">
        <img src="assets/icons/plus.svg" alt="Agregar" class="icon-primary icon icon-32 ">
        <p class="text-button padding-l-sm h2-semibold">
          {{ 'createNewPoint.addRecyclingCenter' | t }}
        </p>
      </button>
    </div>
    
    <div class="empty-state-help">
      <p class="help-text sub text-center text-secondary">
        {{ 'createNewPoint.prefilledNote' | t }}
      </p>
    </div>
  </div>
</div>